import React, { useEffect, useRef, useState } from "react";
import "../Styles/HairSection.css";

function HairCare() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          obs.unobserve(el);
        }
      },
      { threshold: 0.2 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  
  // Hair Make Over
  const careBlocks = [
    {
            //   desc: "gorgeous styling, incredible color services and best hair treatments. Choose your dream service!.",
      items: ["The right to make everyday a great hair day",
    "Shoulder Length",
    "Shampoo + condition + Blow dry",
    "Mid back Length",
    "Haircut & Hair Trim (includes Hair Wash and Blast Dry U.Cut, straight cut & Fringes)",
    "Waist Length",
    "Blow Dry",],
    },
    {
     items: ["Any change of Hair Style",
    "Hair Wash & Ultimate blow dry",
    "Dream curls Tongs",
    "Hair Do",
    "Straight finish ironing",
    "Additional charge for volume / thickness (extra)",],
    },
  ];

 
  const SpaBlocks = [
    [
      { title: "De stress spa", items: ["Shoulder Length", "Mid back Length", "Waist Length"] },
    { title: "Enhance spa", items: ["Shoulder Length", "Mid back Length", "Waist Length"] },
    
    ],
    [
      { title: "Protein spa", items: ["Shoulder Length", "Mid back Length", "Waist Length"] },
    { title: "TREATMENT", items: ["Anti Dandruff", "Anti Hair fall"] },
    { title: "Marocain Oil spa", items: ["Shoulder Length", "Mid back Length", "Waist Length"] },
    ],
  ];

  // WhatsApp
  const handleBookAppointment = () => {
    const phoneNumber = "919912232487";
    const message = encodeURIComponent("Hello! I’d like to book an appointment.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <section ref={sectionRef} className={`hair-section ${isVisible ? "fade-in" : ""}`}>
      
      {/* Hair Make Over */}
      <div id="hair-carer" className="hair-block">
        <h2 className={`hair-title ${isVisible ? "show" : ""}`}>Hair Care</h2>
        <p className="hair-desc">gorgeous styling, incredible color services and best hair treatments.<br/> Choose your dream service!.</p>
        <div className="hair-inner-columns">
          {careBlocks.map((blk) => (
            <div className="spa-block" key={blk.title}>
              <h3 className={`spa-subtitle ${isVisible ? "show" : ""}`}>{blk.title}</h3>
              <p className="hair-desc">{blk.desc}</p>
              <ul className="hair-list">
                {blk.items.map((it, ii) => (
                  <li key={ii} className={`hair-item ${isVisible ? "show" : ""}`}>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Hair Spa */}
      <div id="hair-spa" className="hair-block">
        <h3 className={`hair-title ${isVisible ? "show" : ""}`}>Hair Spa</h3>
        {SpaBlocks.map((col, ci) => (
          <div key={ci} className="hair-inner-columns">
            {col.map((blk) => (
              <div className="spa-block" key={blk.title}>
                <h3 className={`spa-subtitle ${isVisible ? "show" : ""}`}>{blk.title}</h3>
                <ul className="hair-list">
                  {blk.items.map((it, ii) => (
                    <li key={ii} className={`hair-item ${isVisible ? "show" : ""}`}>
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Book Appointment */}
      <div className="text-center" style={{ marginTop: "2rem" }}>
        <button onClick={handleBookAppointment} className="book-btn">
          📅 BOOK APPOINTMENT
        </button>
      </div>
    </section>
  );
}

export default HairCare;
